export const graduationGowns = [
    { name: 'primary_boy', id: '1e78e0ef-c0b2-43a4-8d11-62fc82f7f65d' },
    { name: 'primary_girl', id: 'b1d9e48a-c555-4965-9789-84f8abc3bd3b' },
    { name: 'secondary_boy', id: '9c061ba1-84ba-4042-be02-96a52b38309e' },
    { name: 'secondary_girl', id: '34e1f355-b4b1-40e7-a90b-c428aea30ed2' },
];